import { Injectable, OnInit } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpResponse } from '@angular/common/http';
import { AuthenticationService } from '../../auth';
import { Observable } from 'rxjs';
import { Globals } from '../../globals';
import { Cookie } from 'ng2-cookies';


@Injectable()
export class NewRegisterViewService implements OnInit {

    constructor(private http: HttpClient, private authService: AuthenticationService, private globals: Globals) { }

    ngOnInit() : void {
        this.authService.isTokenValid();
    }
    /**
     * Get RK by id
     * @param rkId unique id of RK
     */
    getRkById(rkId) : Observable<any> {
        this.authService.isTokenValid();
        const url = this.authService.getResourceURL() + '/api/v1/default-registercontrol/' + rkId;
        let requestHeaders = new HttpHeaders()
            .set('Content-Type', 'application/x-www-form-urlencoded; charset=utf-8')
            .set('Authorization', 'Bearer ' + this.authService.getAccessToken());

        return this.http.get(url, {headers: requestHeaders, responseType: 'json'})
    }

    /**
     * Report an existing register control
     * @param rkId rk unique identifier
     * @returns 
     */
    reportRegisterControl(rkId: any, status: String) : Observable<any> {
        this.authService.isTokenValid();
        const url = this.authService.getResourceURL() + '/api/v1/default-registercontrol/status/' + rkId;
        let requestHeaders = new HttpHeaders()
            .set('Content-Type', 'application/x-www-form-urlencoded; charset=utf-8')
            .set('Authorization', 'Bearer ' + this.authService.getAccessToken());

            var statusObj = {};
            statusObj["status"] = status;            

            const body = new HttpParams()
            .set('statusBody', JSON.stringify(statusObj));

            return this.http.put(url, body, {headers: requestHeaders, responseType: 'json'});
    }

    /**
     * Archive rk
     * @param rkId rk unique identifier
     */
    archiveRegisterControl(rkId) : Observable<any> {
        this.authService.isTokenValid();
        const url = this.authService.getResourceURL() + '/api/v1/default-registercontrol/' + rkId;
        let requestHeaders = new HttpHeaders()
            .set('Content-Type', 'application/x-www-form-urlencoded; charset=utf-8')
            .set('Authorization', 'Bearer ' + this.authService.getAccessToken());

        return this.http.delete(url, {headers: requestHeaders, responseType: 'json'});
    }

    /**
     * Get receiver by id
    */
   getReceiverById(receiverId) {
        this.authService.isTokenValid();
        const url = this.authService.getResourceURL() + '/api/v1/receiver_person/' + receiverId;

        let requestHeaders = new HttpHeaders()
            .set('Content-Type', 'application/x-www-form-urlencoded; charset=utf-8')
            .set('Authorization', 'Bearer ' + this.authService.getAccessToken());

        return this.http.get(url, {headers: requestHeaders, responseType: 'json'})
    }  
    
    /**
     * Get a receiver ID based on a name
     */
    deleteRecieverPerson(receiverId) {
        this.authService.isTokenValid();
        const url = this.authService.getResourceURL() + '/api/v1/receiverPerson/delete/' + receiverId;

        let requestHeaders = new HttpHeaders()
            .set('Content-Type', 'application/x-www-form-urlencoded; charset=utf-8')
            .set('Authorization', 'Bearer ' + this.authService.getAccessToken());

        return this.http.delete(url, {headers: requestHeaders, responseType: 'json'});
    }

    /**
     * Get all receivers
     */
    getAllReceivers() {
        this.authService.isTokenValid();
        const url = this.authService.getResourceURL() + '/api/v1/receiverPerson';

        let requestHeaders = new HttpHeaders()
            .set('Content-Type', 'application/x-www-form-urlencoded; charset=utf-8')
            .set('Authorization', 'Bearer ' + this.authService.getAccessToken());

        return this.http.get(url, {headers: requestHeaders, responseType: 'json'})
    }

    /**
     * Save new receiver
     * @param receiver receiver object
     */
    saveReceiver(receiver) : Observable<any> {
        this.authService.isTokenValid();
        const url = this.authService.getResourceURL() + '/api/v1/receiverPerson';
        let requestHeaders = new HttpHeaders()
            .set('Content-Type', 'application/x-www-form-urlencoded; charset=utf-8')
            .set('Authorization', 'Bearer ' + this.authService.getAccessToken());

        const body = new HttpParams()
        .set('receiverPersonBody', JSON.stringify(receiver));

        return this.http.post(url, body, {headers: requestHeaders, responseType: 'json'});
    }

    /**
     * Delete an attachment belonging to rk
     * @param attachmentId uuid of attachment
     * @param rkId uuid of rk 
     */
    deleteAttachment(attachmentId, rkId) : Observable<any> {
        this.authService.isTokenValid();
        const url = this.authService.getResourceURL() + '/api/v1/import/rkattachment/' + attachmentId + '/' + rkId;

        let requestHeaders = new HttpHeaders()
            .set('Content-Type', 'application/x-www-form-urlencoded; charset=utf-8')
            .set('Authorization', 'Bearer ' + this.authService.getAccessToken());

        return this.http.delete(url, {headers: requestHeaders, responseType: 'json'});
    }

    /**
     * Get sapo workflow states
     */
    getSapoWorkflow() {
        this.authService.isTokenValid();
        const url = this.authService.getResourceURL() + '/api/v1/default-registercontrol/sapo/workflow';

        let requestHeaders = new HttpHeaders()
            .set('Content-Type', 'application/x-www-form-urlencoded; charset=utf-8')
            .set('Authorization', 'Bearer ' + this.authService.getAccessToken());

        return this.http.get(url, {headers: requestHeaders, responseType: 'json'})
    }
}
